import { render, staticRenderFns } from "./MediaControllerImagesBox.vue?vue&type=template&id=3b188b5a&scoped=true&"
import script from "./MediaControllerImagesBox.vue?vue&type=script&lang=js&"
export * from "./MediaControllerImagesBox.vue?vue&type=script&lang=js&"
import style0 from "./MediaControllerImagesBox.vue?vue&type=style&index=0&id=3b188b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b188b5a",
  null
  
)

export default component.exports